import React, { FC } from 'react';

import { QUERY_BUILDER_TYPES } from 'src/modules/query-builder/constants';
import { getFormattedDate, isCustomTimeframe } from 'src/utils/misc';
import { ToolbarQueryBadge } from '../toolbar-query-badge';

interface QueryTypeContentProps {
  target: any;
  conversation: any;
  queryBuilderType: typeof QUERY_BUILDER_TYPES[keyof typeof QUERY_BUILDER_TYPES];
}

const formattedDate = date => getFormattedDate(date, 'MMM dd yyyy');

export const QueryTypeContent: FC<QueryTypeContentProps> = ({
  target,
  conversation,
  queryBuilderType,
}) => {
  const isEngagement = target.query_type === 'engagement';
  let label = isEngagement ? 'Timed Interest' : 'Interest';
  let icon = isEngagement ? 'calendar' : 'heart';
  const isConversation = queryBuilderType === QUERY_BUILDER_TYPES.CONVERSATION;

  if (isConversation) {
    icon = 'calendar';
    const timeframe = conversation.timeframes.find(
      timeframe => timeframe.id === target.audience_timeframe
    );
    const isCustom = isCustomTimeframe(target.audience_timeframe);

    if (isCustom) {
      const dates = target.audience_timeframe.split(',');
      label = `Time frame: ${formattedDate(dates[0])} - ${formattedDate(
        dates[1]
      )}`;
    } else {
      label = `Time frame: ${(timeframe && timeframe.label) || ''}`;
    }
  }

  if (isConversation) {
    return (
      <ToolbarQueryBadge
        icon={icon}
        label={label}
        variant="dark"
        className="bg-hx-light-dark"
      />
    );
  } else {
    return (
      <ToolbarQueryBadge
        icon={icon}
        label={label}
        variant="white"
        className="bg-black text-white"
      />
    );
  }
};
